export default __webpack_public_path__ + "static/media/mobile_landing_page_bkgr.cfce0774.png";